export default __webpack_public_path__ + "static/media/1030.2b476b99.svg";